import React, { createElement } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { useT } from '../utils/i18n';
export function Footer() {
  const t = useT();
  return <footer className="pt-12 border-t border-white/10 transition-colors duration-300 bg-[#000000]" data-id="element-804" data-mp="32o4b2ak1486j">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12" data-id="element-805" data-mp="36p6buvtlgsam">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-8 border-b border-white/20 pb-8" data-id="element-806" data-mp="36nd5ziqt2c3o">
          <div className="md:col-span-2" data-id="element-807" data-mp="3ucxmluzhkx9s">
            <Link to="/" className="inline-block mb-4" data-id="element-808" data-mp="38z9qtqtv33y">
              <Logo imgClassName="h-10 w-auto" invertOnLight={false} cycleEvery={3} data-id="element-809" data-mp="36mrefh5qqqd" />
            </Link>
            <p className="text-sm font-medium leading-relaxed max-w-sm text-[#ffffff]" data-id="element-810" data-mp="3lgoocjn8w4p8">
              {t('footer.tagline')}
            </p>
          </div>

          <div data-id="element-811" data-mp="29ydvdx2r0y8b">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-812" data-mp="29xm1qrsppako">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-813" data-mp="2evxa0y3czd0s">
              <li data-id="element-814" data-mp="3l9sj15twaup0">
                <a href="tel:206-619-3742" className="hover:text-white/70 transition-colors" data-id="element-815" data-mp="3lbdecxo1ahnx">
                  (206) 619-3742
                </a>
              </li>
              <li data-id="element-816" data-mp="3v8hq03k96uqh">
                <a href="mailto:info@206gravel.com" className="hover:text-white/70 transition-colors" data-id="element-817" data-mp="3v916dfu99b2e">
                  info@206gravel.com
                </a>
              </li>
              <li data-id="element-818" data-mp="81pejgi0et8b">Bonney Lake, WA</li>
            </ul>
          </div>

          <div data-id="element-819" data-mp="34gt971ke92u">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-820" data-mp="32w3rvu3xgbu">
              {t('footer.hours')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-821" data-mp="hs1yb6i02ide">
              <li className="flex justify-between" data-id="element-822" data-mp="cus134odd2f0">
                <span data-id="element-823" data-mp="qthxei3d6y2b">{t('footer.monFri')}</span>
                <span data-id="element-824" data-mp="qub81u5g27pq">6:00 AM – 5:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-825" data-mp="ms6hx5e7ft7u">
                <span data-id="element-826" data-mp="mthhet0maet5">{t('footer.saturday')}</span>
                <span data-id="element-827" data-mp="tvmrhl25amnh">6:00 AM – 3:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-828" data-mp="tt0a6tpgcss2">
                <span data-id="element-829" data-mp="yv94bte2a0vr">{t('footer.sunday')}</span>
                <span data-id="element-830" data-mp="yrv0shtnvlmq">{t('footer.closed')}</span>
              </li>
            </ul>
          </div>

          <div data-id="element-831" data-mp="13rg04tcqtvzz">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-832" data-mp="18k0ubvzkab41">
              {t('footer.resources')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-833" data-mp="1cmdve73d5kuh">
              <li data-id="element-834" data-mp="1hkfdopsytg4w">
                <Link to="/compare" className="hover:text-white/70 transition-colors" data-id="element-835" data-mp="1hjw90asbso8t">
                  {t('nav.compareMaterials')}
                </Link>
              </li>
              <li data-id="element-836" data-mp="1riv9v76unfl9">
                <Link to="/delivery-prep" className="hover:text-white/70 transition-colors" data-id="element-837" data-mp="1rjemc8dqdbrw">
                  {t('footer.deliveryPrep')}
                </Link>
              </li>
              <li data-id="element-838" data-mp="3ta86l8ynyh68">
                <Link to="/delivery-zones" className="hover:text-white/70 transition-colors" data-id="element-839" data-mp="3t9gdc4sjgvj4">
                  {t('nav.deliveryZones')}
                </Link>
              </li>
              <li data-id="element-840" data-mp="25oey6201rqg9">
                <Link to="/blog" className="hover:text-white/70 transition-colors" data-id="element-841" data-mp="25o59chqqnpc5">
                  {t('footer.blog')}
                </Link>
              </li>
              <li data-id="element-842" data-mp="21kfmpxtmjhtr">
                <Link to="/help" className="hover:text-white/70 transition-colors" data-id="element-843" data-mp="1wnz1bbdt7hkd">
                  {t('footer.materialQuiz')}
                </Link>
              </li>
              <li data-id="element-844" data-mp="2tbvhif5c4av2">
                <Link to="/service-areas" className="hover:text-white/70 transition-colors" data-id="element-845" data-mp="2pceahha9f5ns">
                  Service Areas
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center text-sm font-medium text-white/60" data-id="element-846" data-mp="2fegmmuwbbavp">
          <p data-id="element-847" data-mp="18yeeghejc05t">
            &copy; {new Date().getFullYear()} 206Gravel. {t('footer.rights')}
          </p>
          <div className="mt-4 md:mt-0 space-x-6" data-id="element-848" data-mp="13y04uuxaci5o">
            <Link to="/privacy-policy" className="hover:text-white transition-colors" data-id="element-849" data-mp="141e7835y8rd4">
              {t('footer.privacy')}
            </Link>
            <Link to="/terms-of-service" className="hover:text-white transition-colors" data-id="element-850" data-mp="2wmptiv6ykgqi">
              {t('footer.terms')}
            </Link>
            <Link to="/refund-policy" className="hover:text-white transition-colors" data-id="element-851" data-mp="2isyfpam72aoz">
              {t('footer.refund')}
            </Link>
          </div>
        </div>
      </div>

      {/* Our Network — thin horizontal strip pinned to the very bottom of
                                          the site. Forest-green background, black text. */}
      <div className="w-full bg-[#00754A]" data-id="element-852" data-mp="31mc3mvrhpgv3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex flex-row flex-nowrap items-center justify-center gap-x-3 sm:gap-x-5 text-[11px] sm:text-sm font-bold text-black whitespace-nowrap overflow-x-auto scrollbar-hide" data-id="element-853" data-mp="31lau4vq4h2fh">
          <span className="uppercase tracking-[0.1em] sm:tracking-[0.14em] shrink-0 font-[500] text-[#17A347]" data-id="element-854" data-mp="1v5764es1gbre">
            Our Network
          </span>
          <a href="https://253gravel.com" className="hover:text-black/70 transition-colors font-[500] shrink-0 text-[12px] text-[#17A347]" data-id="element-855" data-mp="1nk4lesxz54o0">
            253gravel.com
          </a>
          <a href="https://206gravel.com" className="hover:text-black/70 transition-colors font-[500] shrink-0 text-[12px] text-[#17A347]" data-id="element-856" data-mp="1wlcjpb0hq5i3">
            206gravel.com
          </a>
          <a href="https://425gravel.com" className="hover:text-black/70 transition-colors font-[500] shrink-0 text-[12px] text-[#17A347]" data-id="element-857" data-mp="13x6ykn5iyehq">
            425gravel.com
          </a>
        </div>
      </div>
    </footer>;
}